var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0084 1H4.66667C2.64162 1 1 2.64163 1 4.66667V23.5867C1 25.6117 2.64162 27.2533 4.66667 27.2533H35.0084C37.0334 27.2533 38.675 25.6117 38.675 23.5867V4.66667C38.675 2.64163 37.0334 1 35.0084 1Z",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.585 27.2354V34.2204",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1084 27.2354V34.2204",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6001 34.2202H32.0935",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7136 7.34375H7.64697C7.09469 7.34375 6.64697 7.79147 6.64697 8.34375V14.4104C6.64697 14.9627 7.09469 15.4104 7.64697 15.4104H13.7136C14.2659 15.4104 14.7136 14.9627 14.7136 14.4104V8.34375C14.7136 7.79147 14.2659 7.34375 13.7136 7.34375Z",
    fill: "#AFD0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0469 7.34375H17.1802C16.6279 7.34375 16.1802 7.79147 16.1802 8.34375V14.4104C16.1802 14.9627 16.6279 15.4104 17.1802 15.4104H32.0469C32.5992 15.4104 33.0469 14.9627 33.0469 14.4104V8.34375C33.0469 7.79147 32.5992 7.34375 32.0469 7.34375Z",
    fill: "#AFD0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.047 16.1436H7.64697C7.09469 16.1436 6.64697 16.5913 6.64697 17.1436V19.5436C6.64697 20.0958 7.09469 20.5436 7.64697 20.5436H32.047C32.5993 20.5436 33.047 20.0958 33.047 19.5436V17.1436C33.047 16.5913 32.5993 16.1436 32.047 16.1436Z",
    fill: "#AFD0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesDesktop);
export default __webpack_public_path__ + "static/media/devices-desktop.2d83c378ec323ada9d96fa055888255a.svg";
export { ForwardRef as ReactComponent };